<script setup lang="ts">
import { SignatureDocumentFieldType } from '@/store/enums';
import { DateTime } from 'luxon';
import {onMounted, Ref, ref} from 'vue';
import {usePortalIntakeStore} from "@/store/PortalIntakeModule";

const props = defineProps<{
    documentIndex: number,
    fieldIndex: number
}>();

const value = ref(DateTime.now().toLocaleString());

const intakeStore = usePortalIntakeStore();
const setDocumentField = (docIndex: number, fieldIndex: number, field: {type: SignatureDocumentFieldType, value: Ref<string|undefined>}) => 
    intakeStore.dispatch('setDocumentField', {docIndex, fieldIndex, field});

onMounted(() =>
    setDocumentField(props.documentIndex, props.fieldIndex, {type: SignatureDocumentFieldType.Date, value})
);
</script>

<template>
    <div>
        <p-input-text
            size="small"
            readonly
            disabled
            class="date-input"
            :val="value"
            :value="value"
        />
        <span class="signature-form-data signature-form-date-signed">
            {{ value }}
        </span>
    </div>
</template>

<style scoped lang="scss">
    .date-input.p-inputtext {
        width: 120px;
    }
</style>
